import { validationTypes } from "../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../data/formFieldType";

const initState = {
    lSalesRepKey: null,
    lPriceListKey: null,
    dtOrderData: null,
    dtQuoteDate: null,
    dtApprovalDate: null,
    dtInvoiceData: null,
};

export const productSalesFormConfig = {


    name: "AddContracts",
    initialState: initState,
    section: [
        {
            sectionId: "basicDetailSection",
            title: "Basic Contracts Details",
            row: {},
            style: {
                sectionStyle: "mt-2",
            },
            wrapperTemplate: <div className="p-2 row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "lSalesRepKey",
                    label: "Sales Rep : ",
                    Field_Name: "Sales Rep",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "lSalesRepKey",
                    fieldSetting: {
                        placeholder: "Select Sales Rep",
                        options: [],
                        isLoading: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 col-6 mb-2",
                    },
                },
                {
                    id: "lInventoryPricingListKey",
                    label: "Price List :",
                    Field_Name: "Price List",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "lInventoryPricingListKey",
                    fieldSetting: {
                        placeholder: "Select Price List",
                        isLoading: false,
                        options: [],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 col-4 mb-2 ",
                    },
                },
                {
                    id: "dtOrderDate",
                    label: "Order Date :",
                    Field_Name: "Order Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "dtOrderDate",
                    fieldSetting: {
                        placeholder: "Select Order Date",
                        isLoading: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 col-4 mb-2 ",
                    },
                },
                {
                    id: "dtQuoteDate",
                    label: "Quote Date :",
                    Field_Name: "Quote Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "dtQuoteDate",
                    fieldSetting: {
                        placeholder: "Enter Quote Date",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 col-4 mb-2 po-input",
                    },
                },
                {
                    id: "dtApprovalDate",
                    label: "Approval Date :",
                    Field_Name: "approval date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "dtApprovalDate",
                    fieldSetting: {
                        placeholder: "Enter Approval Date",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 col-4 mb-2 ",
                    },
                },
                {
                    id: "dtInvoiceDate",
                    label: "Invoice Date :",
                    Field_Name: "invoice date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "dtInvoiceDate",
                    fieldSetting: {
                        placeholder: "Enter Invoice Date",
                        allowSpace: true,
                        isDisable: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 col-4 mb-2",
                    },
                },
            ],
        },
    ],
}
